import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../config/theme';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  page: {
    maxWidth: '768px',
    padding: '40px 24px',
    boxSizing: 'border-box',
  },
  title: {
    fontWeight: 700,
    color: '#2D6E2F',
    textAlign: 'center',
    marginBottom: '24px',
  },
  body: {
    color: '#1A1A1A',
    lineHeight: 1.6,
    textAlign: 'left',
  },
}));

export default function Termos({ content }) {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.page}>
        <Typography variant="h4" className={classes.title}>
          Termos de Uso
        </Typography>
        <div className={classes.body} dangerouslySetInnerHTML={{ __html: content.body }} />
      </div>
    </ThemeProvider>
  );
}
